import { render } from "./CurrentCourse.vue?vue&type=template&id=640eeffc&scoped=true"
import script from "./CurrentCourse.vue?vue&type=script&lang=js"
export * from "./CurrentCourse.vue?vue&type=script&lang=js"

import "./CurrentCourse.vue?vue&type=style&index=0&id=640eeffc&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640eeffc"]])

export default __exports__